(function (window, document) {
  'use strict';

  if (window.__stlPreorderDirectCartLoaded) return;
  window.__stlPreorderDirectCartLoaded = true;
  var initializedForms = new WeakSet();

  function readableShippingWindow(value) {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2}) – (\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return value;
    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    const format = (year, month, day) => `${Number(day)}. ${months[Number(month) - 1]} ${year}`;
    if (![match[2], match[5]].every(month => Number(month) >= 1 && Number(month) <= 12)
      || ![match[3], match[6]].every(day => Number(day) >= 1 && Number(day) <= 31)) return value;
    const start = format(match[1], match[2], match[3]);
    const end = format(match[4], match[5], match[6]);
    return start === end ? `Voraussichtlich ab ${start}` : `Voraussichtlich ${start} – ${end}`;
  }

  function digits(value) { return /^[1-9][0-9]*$/.test(String(value || '')); }
  function localeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && /^\/(?:[a-zA-Z-]+\/)*$/.test(root) ? root : '/';
  }
  function productHandle(rawUrl) {
    try {
      var url = new URL(rawUrl, window.location.origin);
      var match = url.pathname.match(/(?:^|\/)products\/([^/]+)\/?$/);
      return url.origin === window.location.origin && match ? match[1] : null;
    } catch { return null; }
  }
  function parseMap(node) {
    try {
      var map = JSON.parse(node && node.textContent || 'null');
      if (!map || map.version !== 1 || typeof map.productId !== 'string' || !digits(map.productId)
        || typeof map.dropId !== 'string' || !map.dropId
        || typeof map.shippingWindow !== 'string' || !map.shippingWindow
        || map.currency !== 'EUR' || !map.variants
        || typeof map.variants !== 'object' || Array.isArray(map.variants)) return null;
      return map;
    } catch { return null; }
  }
  function validEntry(entry) {
    return entry && typeof entry.variantId === 'string' && digits(entry.variantId)
      && typeof entry.sku === 'string' && entry.sku.length > 0
      && typeof entry.skuId === 'string' && entry.skuId.length > 0
      && typeof entry.color === 'string' && entry.color.length > 0
      && Array.isArray(entry.selectedOptions) && entry.selectedOptions.length === 2
      && entry.selectedOptions[0]?.name === 'Color' && entry.selectedOptions[0]?.value === entry.color
      && entry.selectedOptions[1]?.name === 'Version' && entry.selectedOptions[1]?.value === 'V4'
      && Number.isSafeInteger(entry.priceCents) && entry.priceCents > 0
      && Number.isSafeInteger(entry.quotaAtActivation) && entry.quotaAtActivation > 0;
  }
  function isPreorder(item) {
    return item && item.properties && item.properties._stl_preorder_hold === 'PREORDER_HOLD';
  }
  function cartAllowsPreorder(cart, map) {
    return cart && cart.currency === 'EUR' && Array.isArray(cart.items)
      && cart.items.every(function (item) {
        return isPreorder(item) && String(item.product_id) === map.productId
          && item.properties._stl_drop_id === map.dropId;
      });
  }
  function matchesPreorderLine(item, map, entry) {
    return item && String(item.id) === entry.variantId && String(item.product_id) === map.productId
      && item.sku === entry.sku && isPreorder(item)
      && item.properties._stl_sku_id === entry.skuId && item.properties._stl_drop_id === map.dropId;
  }
  function productMatches(product, map, entry) {
    if (!product || String(product.id) !== map.productId || !Array.isArray(product.variants)) return false;
    var variant = product.variants.find(function (row) { return String(row.id) === entry.variantId; });
    return Boolean(variant && variant.available === true && variant.inventory_management === 'shopify'
      && variant.sku === entry.sku && variant.price === entry.priceCents
      && variant.option1 === entry.selectedOptions[0].value
      && variant.option2 === entry.selectedOptions[1].value && variant.option3 == null);
  }
  function json(response) {
    if (!response.ok) throw new Error('request_failed');
    return response.json();
  }
  function init(form) {
    if (initializedForms.has(form)) return;
    initializedForms.add(form);
    form.dataset.stlPreorderDirectCartReady = 'true';
    var panel = form.querySelector('[data-stl-preorder-route]');
    var map = parseMap(form.querySelector('[data-stl-preorder-route-map]'));
    var handle = productHandle(panel && panel.dataset.productUrl);
    var buttons = Array.from(form.querySelectorAll('[data-stl-preorder-submit]'));
    var status = form.querySelector('[data-stl-preorder-route-status]');
    var title = form.querySelector('[data-stl-preorder-route-title]');
    var price = form.querySelector('[data-stl-preorder-route-price]');
    var listPrice = form.querySelector('[data-stl-preorder-route-list-price]');
    var discountPrice = form.querySelector('[data-stl-preorder-route-discount-price]');
    var shippingWindow = form.querySelector('[data-stl-preorder-route-window]');
    var error = form.querySelector('[data-stl-preorder-route-error]');
    var retry = form.querySelector('[data-stl-preorder-retry]');
    var sticky = form.querySelector('[data-stl-preorder-sticky]');
    var mainButton = form.querySelector('[data-stl-preorder-submit-main]');
    var generation = 0;
    var params = new URLSearchParams(window.location.search);
    var formVariantId = form.querySelector('[name="id"]')?.value || '';
    var requestedId = params.get('variant');
    var ambiguousDeepLink = params.has('color') || Boolean(requestedId && requestedId !== formVariantId);
    var selectedId = ambiguousDeepLink ? '' : formVariantId;
    var readyEntry = null;
    var busy = false;
    var verifiedSelection = null;
    function setBusy(value) {
      busy = value;
      buttons.forEach(function (button) {
        button.setAttribute('aria-busy', String(value));
        button.disabled = value || !readyEntry;
        button.hidden = !readyEntry && !value;
      });
    }

    function setState(message, { entry = null, retryable = false } = {}) {
      readyEntry = entry;
      if (title) title.textContent = entry ? 'Jetzt deine Farbe sichern.' : 'Vorbestellung wird vorbereitet.';
      if (status) {
        status.hidden = retryable;
        status.textContent = retryable ? '' : message;
      }
      if (shippingWindow) shippingWindow.textContent = entry ? map.shippingWindow + '.' : 'Versandfenster wird geprüft.';
      if (error) { error.textContent = retryable ? message : ''; error.hidden = !retryable; }
      if (retry) retry.hidden = !retryable;
      buttons.forEach(function (button) {
        button.hidden = !entry && !busy;
        button.disabled = !entry || busy;
      });
      if (price) {
        price.hidden = !entry;
        if (entry) {
          var formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE',
            { style: 'currency', currency: map.currency });
          if (listPrice) listPrice.textContent = formatter.format(entry.priceCents / 100);
          if (discountPrice) discountPrice.textContent = formatter.format(
            (entry.priceCents - Math.floor(entry.priceCents * 0.1)) / 100);
        }
      }
      updateSticky();
    }
    function updateSticky() {
      if (!sticky) return;
      if (!form.isConnected) {
        window.removeEventListener('scroll', updateSticky);
        window.removeEventListener('resize', updateSticky);
        return;
      }
      var small = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var visible = Boolean(small && readyEntry && mainButton && mainButton.getBoundingClientRect().bottom < 0);
      sticky.hidden = !visible;
      document.documentElement.classList.toggle('stl-preorder-sticky-visible', visible);
    }
    function selectedEntry() {
      if (ambiguousDeepLink) return null;
      var entry = map && map.variants && map.variants[String(selectedId)];
      return validEntry(entry) ? entry : null;
    }
    function selectedItems() {
      var main = selectedEntry();
      if (!main) return null;
      var quantityInput = form.elements.namedItem('quantity');
      var quantity = quantityInput ? Number(quantityInput.value) : 1;
      if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 3) return null;
      var raw = form.elements.namedItem('sf_items')?.value || '';
      if (!raw) return quantity === 1 ? [{ entry: main, quantity: 1 }] : null;
      var counts = new Map();
      for (var part of raw.split(',')) {
        var match = part.match(/^([1-9][0-9]*):([1-3])$/);
        if (!match || counts.has(match[1])) return null;
        counts.set(match[1], Number(match[2]));
      }
      if (!counts.has(String(selectedId))) return null;
      var items = [];
      var ids = new Set();
      for (var pair of counts) {
        var entry = map.variants[pair[0]];
        if (!validEntry(entry) || ids.has(entry.variantId)) return null;
        ids.add(entry.variantId);
        items.push({ entry: entry, quantity: pair[1] });
      }
      return items.reduce(function (sum, item) { return sum + item.quantity; }, 0) === quantity ? items : null;
    }
    function confirmedSelection(cart, items) {
      return cartAllowsPreorder(cart, map) && items.every(function (item) {
        var lines = cart.items.filter(function (line) { return matchesPreorderLine(line, map, item.entry); });
        return lines.length === 1 && lines[0].quantity === item.quantity;
      });
    }
    async function verify() {
      var ownGeneration = ++generation;
      verifiedSelection = null;
      var entry = selectedEntry();
      var items = selectedItems();
      if (!map || !handle || !entry || !items) {
        setState('Diese Farbe ist für die Vorbestellung noch nicht bereit.');
        return null;
      }
      setState('Verfügbarkeit der gewählten Farbe wird geprüft.');
      try {
        var root = localeRoot();
        var results = await Promise.all([
          window.fetch(root + 'products/' + encodeURIComponent(handle) + '.js',
            { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json),
          window.fetch(root + 'cart.js',
            { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json),
        ]);
        if (ownGeneration !== generation || JSON.stringify(selectedItems()) !== JSON.stringify(items)) return null;
        if (!items.every(function (item) { return productMatches(results[0], map, item.entry); })) {
          setState('Diese Farbe ist ausverkauft oder ihre Vorbestellung ist noch nicht freigegeben.');
          return null;
        }
        if (!cartAllowsPreorder(results[1], map)) {
          setState('Bitte schließe verfügbare Artikel zuerst als separate Bestellung ab.');
          return null;
        }
        if (results[1].items.some(function (line) { return items.some(function (item) { return matchesPreorderLine(line, map, item.entry); }); })) {
          setState('Diese Farbe liegt bereits im Warenkorb. Bitte prüfe deine Bestellung dort.');
          return null;
        }
        verifiedSelection = JSON.stringify(items);
        setState('Farbe ' + entry.color + ' verfügbar · Vorbestellung möglich.', { entry });
        return items;
      } catch {
        if (ownGeneration === generation) setState('Verfügbarkeit konnte nicht geprüft werden. Bitte erneut prüfen.', { retryable: true });
        return null;
      }
    }
    async function add() {
      if (busy || !readyEntry) return;
      var items = selectedItems();
      if (!items || JSON.stringify(items) !== verifiedSelection) { void verify(); return; }
      setBusy(true);
      var entry = selectedEntry();
      if (window.stlOrderTypeGuard && !window.stlOrderTypeGuard.canAddForm(form)) {
        setBusy(false); setState('Bitte bestelle verfügbare Artikel separat.'); return;
      }
      var additions = items.map(function (item) {
        return { id: Number(item.entry.variantId), quantity: item.quantity, properties: {
          _stl_drop_id: map.dropId,
          _stl_sku_id: item.entry.skuId,
          _stl_preorder_hold: 'PREORDER_HOLD',
          Vorbestellung: 'Zahlung sofort',
          Versandfenster: readableShippingWindow(map.shippingWindow),
        } };
      });
      try {
        setState('Vorbestellung wird in den Warenkorb gelegt.', { entry });
        var response = await window.fetch(localeRoot() + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: additions }),
        });
        if (!response.ok) throw new Error('cart_add_failed');
        var added = await response.json();
        if (!Array.isArray(added?.items) || added.items.length !== items.length
          || !items.every(function (item) {
            return added.items.some(function (line) {
              return matchesPreorderLine(line, map, item.entry)
                && line.quantity === item.quantity && isPreorder(line)
                && line.properties._stl_sku_id === item.entry.skuId && line.properties._stl_drop_id === map.dropId;
            });
          })) throw new Error('cart_readback_failed');
        // A successful Shopify add response already confirms the committed
        // lines. Inventory and checkout validation remain enforced by Shopify.
        // Read the full cart only when the mutation outcome is ambiguous.
        window.location.assign(localeRoot() + 'cart');
      } catch {
        // A lost add.js response is ambiguous. Check the cart before offering a
        // retry, so an already-committed line is not added twice.
        try {
          var cartAfterError = await window.fetch(localeRoot() + 'cart.js',
            { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json);
          if (confirmedSelection(cartAfterError, items)) {
            window.location.assign(localeRoot() + 'cart');
            return;
          }
        } catch { /* A readback failure must not invent a successful add. */ }
        setBusy(false);
        setState('Die Vorbestellung konnte nicht bestätigt werden. Bitte prüfe den Warenkorb vor einem erneuten Versuch.', { retryable: true });
      }
    }

    form.addEventListener('submit', function (event) { event.preventDefault(); event.stopImmediatePropagation(); }, true);
    form.addEventListener('variant:change', function (event) {
      ambiguousDeepLink = false;
      selectedId = String(event.detail && event.detail.variant && event.detail.variant.id || '');
      void verify();
    });
    form.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') {
        ambiguousDeepLink = false;
        selectedId = String(event.target.value || '');
        void verify();
      }
    });
    // Offer inputs are form-associated but outside the form element.
    var picker = document.querySelector('sf-offer-picker[form="' + (form.getAttribute('id') || '').replace(/[^A-Za-z0-9_-]/g, '') + '"]');
    if (picker) {
      var offerTimer;
      var onOfferChange = function () {
        if (busy) return;
        window.clearTimeout(offerTimer);
        offerTimer = window.setTimeout(function () { void verify(); }, 0);
      };
      picker.addEventListener('change', onOfferChange);
      picker.addEventListener('click', onOfferChange);
    }
    buttons.forEach(function (button) { button.addEventListener('click', function () { void add(); }); });
    if (retry) retry.addEventListener('click', function () { void verify(); });
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    void verify();
  }

  function initCountdowns() {
    document.querySelectorAll('[data-stl-drop-countdown]').forEach(function (banner) {
      if (banner.dataset.initialized) return;
      banner.dataset.initialized = 'true';
      var target = Date.parse(banner.dataset.target);
      if (!Number.isFinite(target)) return;
      var clock = banner.querySelector('[data-stl-drop-clock]');
      var timer;
      function tick() {
        if (!banner.isConnected) { window.clearInterval(timer); return; }
        var remaining = target - Date.now();
        if (remaining <= 0) { clock.hidden = true; window.clearInterval(timer); return; }
        var minutes = Math.floor(remaining / 60000);
        banner.querySelector('[data-stl-drop-days]').textContent = String(Math.floor(minutes / 1440)).padStart(2, '0');
        banner.querySelector('[data-stl-drop-hours]').textContent = String(Math.floor(minutes / 60) % 24).padStart(2, '0');
        banner.querySelector('[data-stl-drop-minutes]').textContent = String(minutes % 60).padStart(2, '0');
        clock.hidden = false;
      }
      timer = window.setInterval(tick, 30000);
      tick();
    });
  }
  function initAll() {
    initCountdowns();
    document.querySelectorAll('[data-stl-preorder-route]').forEach(function (panel) {
      var form = panel.closest('form[data-type="add-to-cart-form"]');
      if (form) init(form);
    });
  }
  document.addEventListener('shopify:section:load', initAll);
  if (window.MutationObserver && document.body) {
    new window.MutationObserver(function (records) {
      if (records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-stl-preorder-route]')
            || node.querySelector('[data-stl-preorder-route]'));
        });
      })) initAll();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
})(window, document);
